<template>
  <v-row>
    <v-col cols="12">
      <v-row>
        <v-col cols="12">
          <v-data-table
            :headers="headers"
            :items="items"
            dense
            hide-default-footer
            disable-pagination
          >
          </v-data-table>
        </v-col>
      </v-row>
    </v-col>
  </v-row>
</template>

<script>
export default {
  data() {
    return {
      headers: [
        {
          id: 1,
          text: "Nomor Faktur Awal",
          align: "center",
          sortable: false,
          value: "nomorFakturAwal",
          divider: true,
          class: "light-blue lighten-2 font-weight-black",
        },
        {
          id: 2,
          text: "Nomor Faktur Akhir",
          align: "center",
          sortable: false,
          value: "nomorFakturAkhir",
          divider: true,
          class: "light-blue lighten-2 font-weight-black",
        },
        {
          id: 3,
          text: "Nomor Terakhir yang Dipakai",
          align: "center",
          sortable: false,
          value: "nomorTerakhir",
          divider: true,
          class: "light-blue lighten-2 font-weight-black",
        },
        {
          id: 4,
          text: "Nomor Faktur yang Terlewat",
          align: "center",
          sortable: false,
          value: "nomorFakturTerlewat",
          divider: true,
          class: "light-blue lighten-2 font-weight-black",
        },
      ],
      items: [],
    };
  },
};
</script>

<style></style>
